import { resolve, define } from 'acast-www-utils';

export default class MemoryAdapter {
  constructor(data = {}) {
    this.data = data;
  }

  get(key) {
    return resolve(this.data, key);
  }

  set(key, value) {
    return define(this.data, key, value);
  }
}
